import { Component, OnInit, Input } from '@angular/core';
import { trigger, animate, style, transition } from '@angular/animations';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  animations: [
    trigger('alertState', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class AlertComponent implements OnInit {

  @Input() msg;
  @Input() dismissible = false;
  @Input() title;
  @Input() type = 'success';

  public alertState;

  constructor() { }

  ngOnInit() {
  }

}
